import { useEffect, useRef } from "react"

const TRUSTPILOT_SCRIPT_ID = "trustpilot-micro-combo-bootstrap"
const TRUSTPILOT_SCRIPT_SRC = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"

/**
 * Trustpilot "Micro Combo" widget (stars + TrustScore + review count).
 *
 * Loads the bootstrap script once, then forces Trustpilot to hydrate this
 * specific widget instance via loadFromElement (the SPA-safe way, since the
 * script's auto-scan only runs at load). Values are GHD's Trustpilot Micro
 * Combo (golfholidaysdirect.com).
 */
export default function TrustpilotMicroCombo() {
	const widgetRef = useRef(null)

	useEffect(() => {
		const widgetElement = widgetRef.current
		if (!widgetElement) return undefined

		// Load the bootstrap once, then force Trustpilot to hydrate this instance.
		const handleScriptReady = () => {
			window.Trustpilot?.loadFromElement?.(widgetElement, true)
		}

		const existingScript = document.querySelector(`script[src="${TRUSTPILOT_SCRIPT_SRC}"]`)

		if (existingScript) {
			if (window.Trustpilot?.loadFromElement) {
				handleScriptReady()
				return undefined
			}
			existingScript.addEventListener("load", handleScriptReady)
			return () => existingScript.removeEventListener("load", handleScriptReady)
		}

		const script = document.createElement("script")
		script.id = TRUSTPILOT_SCRIPT_ID
		script.src = TRUSTPILOT_SCRIPT_SRC
		script.async = true
		script.addEventListener("load", handleScriptReady)
		document.body.appendChild(script)

		return () => script.removeEventListener("load", handleScriptReady)
	}, [])

	return (
		<div className="pq-trustpilot">
			<div
				ref={widgetRef}
				className="trustpilot-widget"
				data-locale="en-GB"
				data-template-id="5419b6ffb0d04a076446a9af"
				data-businessunit-id="5b2cc6191e3c8c0001aea1de"
				data-style-height="20px"
				data-style-width="100%"
				data-token="57c4d647-2949-49cc-875f-eed90839c5b9">
				<a href="https://uk.trustpilot.com/review/golfholidaysdirect.com" target="_blank" rel="noopener noreferrer">
					Trustpilot
				</a>
			</div>
		</div>
	)
}
